import Axios from '../axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { deserialize, serialize } from '../utility/serialization'
import { handleAPIError } from '../utility/actionHelper'

// THUNKS

export const addStudentsToWaitlist = createAsyncThunk(
  'programPresentation/addStudentsToWaitlist',
  async ({ course, students }, { rejectWithValue }) => {
    try {
      const { data } = await requestAddStudentsToWaitlist(course, students)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const addStudentsToWaitlistManually = createAsyncThunk(
  'waitlist/addStudentsToWaitlistManually',
  async ({ course, students, coachMessage }, { rejectWithValue }) => {
    try {
      const { data } = await requestAddStudentsToWaitlistManually(course, students, coachMessage)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const addStudentToProgram = createAsyncThunk(
  'waitlist/addStudentToProgram',
  async ({ course, waitlistEntry, coachMessage, packageId }, { rejectWithValue }) => {
    try {
      const { data } = await requestAddStudentToProgram(course, waitlistEntry, coachMessage, packageId)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const transferStudentToProgram = createAsyncThunk(
  'waitlist/transferStudentToProgram',
  async ({ course, waitlistEntry, coachMessage, packageId }, { rejectWithValue }) => {
    try {
      const { data } = await requestAddStudentToProgram(course, waitlistEntry, coachMessage, packageId, true)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const inviteStudentToProgram = createAsyncThunk(
  'waitlist/inviteStudentToProgram',
  async ({ course, waitlistEntry, coachMessage }, { rejectWithValue }) => {
    try {
      const { data } = await requestInviteStudentToProgram(course, waitlistEntry, coachMessage)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const removeStudentFromWaitlist = createAsyncThunk(
  'waitlist/removeStudentFromWaitlist',
  async ({ course, waitlistEntry, coachMessage }, { rejectWithValue }) => {
    try {
      const { data } = await requestRemoveStudentFromWaitlist(course, waitlistEntry, coachMessage)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const inviteStudentToAnotherProgram = createAsyncThunk(
  'waitlist/inviteStudentToAnotherProgram',
  async ({ course, waitlistEntry, coachMessage, targetCourseId }, { rejectWithValue }) => {
    try {
      const { data } = await requestInviteStudentToAnotherProgram(course, waitlistEntry, coachMessage, targetCourseId)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

// API CALLS

function requestAddStudentsToWaitlist(course, students) {
  const requestUrl = `/api/v1/courses/${course.id}/waitlist_entries`

  return Axios.post(requestUrl, serialize({ students }))
}

function requestAddStudentsToWaitlistManually(course, students, coachMessage) {
  const requestUrl = `/api/v1/coach/courses/${course.id}/waitlist_entries`

  return Axios.post(requestUrl, serialize({ students, coachMessage }))
}

function requestAddStudentToProgram(course, waitlistEntry, coachMessage, packageId, waitlistTransfer = false) {
  const requestUrl = `/api/v1/coach/courses/${course.id}/waitlist_entries/${waitlistEntry.id}/enroll_student`

  return Axios.post(requestUrl, serialize({ coachMessage, packageId }), { params: serialize({ waitlistTransfer }) })
}

function requestRemoveStudentFromWaitlist(course, waitlistEntry, coachMessage) {
  const requestUrl = `/api/v1/coach/courses/${course.id}/waitlist_entries/${waitlistEntry.id}?coach_message=${coachMessage}`

  return Axios.delete(requestUrl)
}

function requestInviteStudentToProgram(course, waitlistEntry, coachMessage) {
  const requestUrl = `/api/v1/coach/courses/${course.id}/invitations`

  return Axios.post(requestUrl, serialize({ waitlistEntryId: waitlistEntry.id, coachMessage }))
}

function requestInviteStudentToAnotherProgram(course, waitlistEntry, coachMessage, targetCourseId) {
  const requestUrl = `/api/v1/coach/courses/${course.id}/invitations/to_another_course`

  return Axios.post(requestUrl, serialize({ waitlistEntryId: waitlistEntry.id, coachMessage, targetCourseId }))
}
